import { getStopFieldPath } from "@RequestFormV2/sections/Schedule/utils/fieldPaths";
import type { SharedAddressFieldPaths, SharedContactFieldPaths } from "./sharedAddressFieldPaths";

export function getStopSharedAddressFieldPaths(stopIndex: number): SharedAddressFieldPaths {
  return {
    address_type: getStopFieldPath(stopIndex, "stop_address_type"),
    address_id: getStopFieldPath(stopIndex, "address_id"),
    address_name: getStopFieldPath(stopIndex, "address_name"),
    address_reference_number: getStopFieldPath(stopIndex, "address_reference_number"),
    address_street: getStopFieldPath(stopIndex, "street_address"),
    address_street_line2: getStopFieldPath(stopIndex, "street_address_line_two"),
    address_city: getStopFieldPath(stopIndex, "city_name"),
    address_state: getStopFieldPath(stopIndex, "state_name"),
    address_country: getStopFieldPath(stopIndex, "country_name"),
    address_zipcode: getStopFieldPath(stopIndex, "zipcode"),
    airport_name: getStopFieldPath(stopIndex, "stop_airport_name"),
    airport_code: getStopFieldPath(stopIndex, "stop_airport_code"),
    seaport_name: getStopFieldPath(stopIndex, "stop_seaport_name"),
    seaport_code: getStopFieldPath(stopIndex, "stop_seaport_code"),
  };
}

export function getStopSharedContactFieldPaths(stopIndex: number): SharedContactFieldPaths {
  return {
    contact_name: getStopFieldPath(stopIndex, "stop_contact_name"),
    contact_phone: getStopFieldPath(stopIndex, "stop_contact_number"),
    contact_email: getStopFieldPath(stopIndex, "stop_contact_email"),
  };
}
